import { Record } from 'immutable'
import { EmailType } from './enums'

export interface IEmailAddress {
  readonly emailAddress: string
  readonly type: EmailType
}

const EmailAddressRecord = Record({
  emailAddress: '',
  type: EmailType.Work,
})

export class EmailAddress extends EmailAddressRecord implements IEmailAddress {
  public static fromJS(initialState?: Partial<IEmailAddress>) {
    return new EmailAddress(initialState)
  }

  public readonly emailAddress: string
  public readonly type: EmailType

  constructor(initialState?: Partial<EmailAddress>) {
    initialState ? super(initialState) : super()
  }
}
